import { z } from "zod";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const addressShapeSchema = {
	streetName: ZodStringNullable,
	houseNumber: ZodStringNullable,
	city: ZodStringNullable,
	zipCode: ZodStringNullable,
};

export const addressRequiredShapeSchema = {
	streetName: z.string().min(1),
	houseNumber: z.string().optional(),
	city: z.string().min(1),
	zipCode: z.string().min(1),
};

export const addressSchema = z.object(addressShapeSchema);
export const addressRequiredSchema = z.object(addressRequiredShapeSchema);

export type AddressFormSchema = z.infer<typeof addressSchema>;
export type AddressRequiredFormSchema = z.infer<typeof addressRequiredSchema>;
